import { TapestryField } from '@tapestry/types';

export const COMPONENTS_SORTING_ORDER = [
  TapestryField.SubTask,
  TapestryField.Duration,
  TapestryField.MoreInformation,
  TapestryField.Links,
];
